import { render, staticRenderFns } from "./WorkCategoryAndAttributeFilter.vue?vue&type=template&id=1f439a74&scoped=true"
import script from "./WorkCategoryAndAttributeFilter.vue?vue&type=script&lang=js"
export * from "./WorkCategoryAndAttributeFilter.vue?vue&type=script&lang=js"
import style0 from "./WorkCategoryAndAttributeFilter.vue?vue&type=style&index=0&id=1f439a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f439a74",
  null
  
)

export default component.exports